import { AnyObj } from "./utils-types";

export const getFormattedFilterList = (currentFilterList: AnyObj) => {
  if (Array.isArray(currentFilterList)) {
    const filter = currentFilterList.reduce((acc, actual) => {
      if (
        !actual.data?.displayText &&
        !actual.data?.start &&
        !actual.data?.name
      )
        return acc;
      const key = actual.type?.toLowerCase();

      const filterObject = {
        data: actual.data,
        id: actual.id
      };

      if (acc[key]) acc[key].push(filterObject);
      else acc[key] = ["date"].includes(key) ? filterObject : [filterObject];

      return acc;
    }, {});
    return { ...filter };
  }
  return {};
};
